/**
 * Plot Fullscreen Modal
 * Fullscreen dialog for displaying plots with preserved state
 */

import React from 'react';
import { Dialog, AppBar, Toolbar, Typography, IconButton, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { colors } from '../theme/colors';
import { shadows } from '../theme/shadows';

interface PlotFullscreenModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}

export const PlotFullscreenModal: React.FC<PlotFullscreenModalProps> = ({
  open,
  onClose,
  title,
  children,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xl"
      PaperProps={{
        sx: {
          height: 'calc(100vh - 64px)',
          borderRadius: 4,
          background: colors.background.paper,
          boxShadow: shadows.xl,
        },
      }}
      BackdropProps={{
        sx: {
          backdropFilter: 'blur(4px)',
          backgroundColor: colors.overlay.medium,
        },
      }}
    >
      <AppBar
        position="static"
        elevation={0}
        sx={{
          background: colors.primary.gradient,
          borderTopLeftRadius: 16,
          borderTopRightRadius: 16,
        }}
      >
        <Toolbar>
          <Typography
            variant="h6"
            component="div"
            sx={{ flexGrow: 1, color: colors.text.inverse, fontWeight: 600 }}
          >
            {title}
          </Typography>
          <IconButton
            edge="end"
            color="inherit"
            onClick={onClose}
            aria-label="Закрыть"
            sx={{
              color: colors.text.inverse,
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Box
        sx={{
          p: 3,
          overflowY: 'auto',
          height: '100%',
        }}
      >
        {children}
      </Box>
    </Dialog>
  );
};
